import {
  ESdChangeReason,
  ESymbolCategory,
  IAction,
  IActionParameter,
  IDesign,
  IDisplayItem
} from "@kuika/kuika-cl-model";
import _ from "lodash";
import { IWithSDProps, withSD } from "../../../../shared/hoc/screen-design-consumer";
import { IWithContextProp, withContext } from "../../../../shared/hoc/with-context";
import { PureSdComponent } from "../../../../shared/pure-sd";
import KuikaSelectbox, { KuikaSelectboxOption } from "../../../ui-kit/kuika-selectbox/kuika-selectbox";
import { IActionPanelStatesCanBeUpdatedFromChild } from "./action-panel";

const LAYOUT_POSITION_OPTIONS: KuikaSelectboxOption[] = [
  { key: "left", value: "left", label: "Left" },
  { key: "right", value: "right", label: "Right" },
  { key: "top", value: "top", label: "Top" },
  { key: "bottom", value: "bottom", label: "Bottom" }
];

export interface IToggleLayoutSymbolsGroupState {}

export interface IToggleLayoutSymbolsGroupProps {
  action: IAction;
  parameters: IActionParameter[];
  updateValues: (value: IActionPanelStatesCanBeUpdatedFromChild) => void;
}

class ToggleLayoutSymbolsGroup extends PureSdComponent<
  IToggleLayoutSymbolsGroupProps & IWithSDProps & IWithContextProp,
  IToggleLayoutSymbolsGroupState
> {
  constructor(props: IToggleLayoutSymbolsGroupProps & IWithSDProps & IWithContextProp) {
    super(props);
  }

  getScreenDesignContextProviderValues = () => {
    return this.props.sd;
  };

  handlePositionSelect = (value: string): void => {
    const params = _.cloneDeep(this.props.parameters);
    const positionParameter = this.props.parameters.find((element) => element.name === "position");
    if (positionParameter === undefined) {
      return;
    }
    if (!positionParameter.symbol) positionParameter.symbol = {} as any;
    positionParameter.symbol.fixedValue = value;
    positionParameter.symbol.category = ESymbolCategory.fixed;
    const valuesToUpdate = {
      actionParameters: params
    } as IActionPanelStatesCanBeUpdatedFromChild;
    valuesToUpdate.actionParameters?.push(positionParameter);
    this.props.updateValues(valuesToUpdate);
  };

  getPositionSelectValue = (): string | undefined => {
    const positionParameter: IActionParameter | undefined = this.props.parameters.find(
      (element: IActionParameter): boolean => element.name === "position"
    );
    if (positionParameter?.symbol) {
      const fixedValue: unknown = positionParameter.symbol.fixedValue;
      return fixedValue === undefined || fixedValue === null ? undefined : String(fixedValue);
    }
    return "left";
  };

  renderPositionSelect = (): JSX.Element => {
    return (
      <>
        <div style={{ marginTop: 12 }} className="kuika_add_actions_properties_name">
          Layout Position
        </div>
        <div className="kuika_property-grid-column">
          <KuikaSelectbox
            size="sm"
            style={{ width: "100%" }}
            value={this.getPositionSelectValue() ?? null}
            onChange={(val: string): void => {
              this.handlePositionSelect(val);
            }}
            className="kuika_add_actions_inputs_size"
            options={LAYOUT_POSITION_OPTIONS}
          />
        </div>
      </>
    );
  };

  getAllDisplayItemsOfDi = (di: IDisplayItem, result: IDisplayItem[]) => {
    if (di.children)
      for (let i = 0; i < di.children.length; i++) {
        if (!di.children[i].friendlyName) {
          di.children[i].friendlyName = di.children[i].id.toString();
        }
        result.push(di.children[i]);
        this.getAllDisplayItemsOfDi(di.children[i], result);
      }
  };

  fillAllDisplayItemsRecursive = (sd: IDesign, result: IDisplayItem[]) => {
    if (sd.displayItems)
      for (let i = 0; i < sd.displayItems.length; i++) {
        if (!sd.displayItems[i].friendlyName) {
          sd.displayItems[i].friendlyName = sd.displayItems[i].id.toString();
        }
        result.push(sd.displayItems[i]);
        this.getAllDisplayItemsOfDi(sd.displayItems[i], result);
      }
  };

  render() {
    return <div style={{ width: "100%" }}>{this.renderPositionSelect()}</div>;
  }

  checkNeedRender = (changeReason: ESdChangeReason): boolean => {
    return false;
  };
}

const toggleLayoutSymbolsGroup = withContext<IToggleLayoutSymbolsGroupProps>(
  withSD<IToggleLayoutSymbolsGroupProps>(ToggleLayoutSymbolsGroup)
);
export { toggleLayoutSymbolsGroup as ToggleLayoutSymbolsGroup };
